import { useQueries, useQuery } from '@tanstack/react-query';

import useCurrentBrand from '~/hooks/useCurrentBrand';

import SearchService, { KNOWN_TYPEAHEAD_TYPES, TypeaheadBrand } from '~/services/SearchService';

export type Destination = {
  fk?: string;
  primary_text?: string;
  secondary_text?: string;
  type?: string;
  id?: string;
};

interface UseDestinationsTypeaheadParams {
  query: string;
  enabled?: boolean;
}

const STALE_TIME = 10 * 60 * 1000;

export function useDestinationsTypeahead({ query, enabled = true }: UseDestinationsTypeaheadParams) {
  const brand = useCurrentBrand();
  return useQuery({
    queryKey: ['destinations', 'typeahead', query, brand],
    queryFn: async () => {
      if (query.length < 2) {
        return { result: { results: [] } };
      }
      const result = await SearchService.typeahead(query, {
        type: KNOWN_TYPEAHEAD_TYPES,
        brand: brand.toLowerCase() as TypeaheadBrand,
        region: 'AU',
        limit: 20,
        priority: 'current',
      });
      return result;
    },
    enabled: enabled && query.length >= 2,
    staleTime: STALE_TIME,
  });
}

interface UsePlacesParams {
  placeIds: Array<string>;
  enabled?: boolean;
}

export function usePlaces({ placeIds, enabled = true }: UsePlacesParams) {
  return useQueries({
    queries: placeIds.map((placeId) => ({
      queryKey: ['destinations', 'place', placeId],
      queryFn: async () => {
        const result = await SearchService.getPlace(placeId);
        return {
          placeId,
          result,
        };
      },
      enabled: enabled && !!placeId,
      staleTime: STALE_TIME,
    })),
  });
}
